import React, { useState, useEffect } from "react";

const TypingMaster = () => {
    const sampleText = "The quick brown fox jumps over the lazy dog.";
    const [inputText, setInputText] = useState("");
    const [startTime, setStartTime] = useState(null);
    const [accuracy, setAccuracy] = useState(100);
    const [speed, setSpeed] = useState(0);
    const [timeElapsed, setTimeElapsed] = useState(0);
    const [isTypingComplete, setIsTypingComplete] = useState(false);

    useEffect(() => {
        let timer;
        if (startTime && !isTypingComplete) {
            timer = setInterval(() => {
                setTimeElapsed(((Date.now() - startTime) / 1000).toFixed(2));
            }, 100);
        }
        return () => clearInterval(timer);
    }, [startTime, isTypingComplete]);

    useEffect(() => {
        if (inputText.length === 1 && startTime === null) {
            setStartTime(Date.now());
        }

        if (inputText.length === sampleText.length) {
            calculateResults();
            setIsTypingComplete(true);
        }
    }, [inputText]);

    const calculateResults = () => {
        const endTime = Date.now();
        const timeTaken = (endTime - startTime) / 1000 / 60; // in minutes
        const wordsPerMinute = (sampleText.split(" ").length / timeTaken).toFixed(2);
        setSpeed(wordsPerMinute);

        let correctChars = 0;
        for (let i = 0; i < inputText.length; i++) {
            if (inputText[i] === sampleText[i]) correctChars++;
        }
        setAccuracy(((correctChars / sampleText.length) * 100).toFixed(2));
    };

    const resetTest = () => {
        setInputText("");
        setStartTime(null);
        setAccuracy(100);
        setSpeed(0);
        setTimeElapsed(0);
        setIsTypingComplete(false);
    };

    const renderHighlightedText = () => {
        return sampleText.split("".split("")).map((char, index) => {
            let color = "text-black";
            if (index < inputText.length) {
                color = inputText[index] === char ? "text-green-500" : "text-red-500";
            }
            return (
                <span key={index} className={`${color} transition-colors duration-200`}>
                    {char}
                </span>
            );
        });
    };

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <h3 className="mt-2">Typing Master</h3>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-1"></div>
                    <div className="col-md-6 typing_box">
                        <h4 className="text-white">{renderHighlightedText()}</h4>
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-3 typing_box">
                        <h4 className="timer_text text-white">{timeElapsed} seconds</h4>
                    </div>
                    <div className="col-md-1"></div>
                </div>

                <div className="row">
                    <div className="col-md-1"></div>
                    <div className="col-md-6">
                        <div className="col-md-1"></div>

                        <textarea
                            className="typing_text_area"
                            rows="3"
                            value={inputText}
                            onChange={(e) => {
                                const newText = e.target.value;
                                if (newText.length >= inputText.length) {
                                    setInputText(newText);
                                }
                            }}
                            placeholder="Start typing here..."
                            disabled={isTypingComplete}
                        />


                        <div className="options">
                            <form action="">

                            </form><br /><br /><br />
                            <button className="pay_now_btn mt-4 px-4 py-2 bg-blue-500 text-white rounded"
                                onClick={resetTest}
                                style={{ width: 'fit-content' }}>Restart Test</button>
                        </div>
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-3 typing_box">
                        <h4 className="suggetion">
                            <p>Speed: {speed} WPM</p><br />
                            <p>Accuracy: {accuracy}%</p>
                        </h4>
                        <br />
                    </div>
                    <div className="col-md-1"></div>
                </div>

            </div>
        </>
    );
};

export default TypingMaster;
